<script>
import setWindowHistory from "@utils/window-history";
import formatTextUpperCasefirst from "@utils/format-text-upper-casefirst";

export default {
  props: {
    value: {
      type: Number,
      default: 0
    },
    stepList: {
      type: Array,
      default: () => {
        return [
          {
            title: '2021/05/08 已使用',
            value: 0
          },
          {
            title: '2021/05/09 已使用',
            value: 1
          },
          {
            title: '',
            value: 2
          },
          {
            title: '',
            value: 3
          }
        ]
      }
    },
    type: {
      type: String,
      default: 'base',
      validator(value) {
        return [
          'base',
          'history',
        ].includes(value)
      },
    },
  },
  computed: {
    dataValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value);
      }
    },
  },
  methods: {
    formatTextUpperCasefirst,
    onClickStep(index) {
      this.dataValue = index
    }
  }
}
</script>
<!-- section template -->
<template>
  <el-steps
    :active="dataValue"
    class="isStyleStepJtails"
    :class="[$style.baseStepJtails, { isHistory: type === 'history' }]"
  >
    <el-step
      v-for="(stepItem, index) in stepList"
      :key="`stepList-${index}`"
      :title="stepItem.title"
      :class="{ isUse: !!stepItem.title }"
      @click.native="stepItem.title && type === 'history' ? onClickStep(index) : ''"
    ></el-step>
  </el-steps>
</template>
<!-- section style -->
<style lang="scss" module>
.baseStepJtails {
  :global {
    .baseStepJtails {
      @include unstyled;
    }
  }
}
</style>
